<template>
  
   
    <b-row class="pt-2">
      <b-col lg="12">
        <h3>
          <span class="bd-content-title">
            {{$t('exchange.DocumentList')}}
          </span>
        </h3>
      </b-col>
      
      <b-col lg="5">
        <div class="w-100">
            <b-btn size="sm" @click="showDocModal()">Create new doc</b-btn>
        </div>
        <b-form-group
          :label="$i18n.locale()=='kz' ? 'Іздеу' : 'Поиск'"
          label-cols-sm="1"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mb-2 mt-3"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              :placeholder="$i18n.locale()=='kz' ? 'Іздеу' : 'Поиск'"
            ></b-form-input>
            
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="4" class="pt-3">
        <!-- <select  class="form-control text-center" v-model="roleId" @change="sysChange">
          <option :value=0>{{$t("comboChooseText")}}</option>
          <option v-for="(r,ri) in roles" :key="ri" :value="r.id">{{r.name.toUpperCase().trim()}}</option>
          
        </select> -->
      </b-col>
      <b-col lg="3" class="pt-3 text-right">
        <strong>
          {{$i18n.locale()=='kz' ? 'Жалпы саны:' : 'Общее число'}}
        </strong> {{totalRows}}  
      </b-col>
      <b-table 
        ref="docTable"
        striped hover selectable
        :items="docProvider" 
        :fields="fields"
        :busy.sync="isBusy"
        :current-page="currentPage"
        :per-page="perPage"
        :table-variant="tableVariant"
        :filter="filter"
        :select-mode="selectMode"
        selected-variant="danger" 
        >
       
        <template v-slot:table-busy>
          <div class="text-center text-info my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Жүктелуде...</strong>
          </div>
        </template> 
        <template v-slot:cell(actions)="row">
          <b-button size="sm" variant="primary" @click="viewDoc(row.item)">
            <b-icon icon="eye"></b-icon>
          </b-button>
          <b-button size="sm" variant="danger" class="ml-2" @click="deleteDoc(row.item)">
            <b-icon icon="trash"></b-icon>
          </b-button>
        </template>  
      </b-table>
      <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
      ></b-pagination>
      <b-modal id="docModal"  title="ADD NEW DOC" hide-footer>
        <b-row>
          <b-col lg="12">
            <label for="docName">DOC NAME</label>
            <b-form-input class="form-control" v-model="docForm.docName"></b-form-input>
          </b-col>
          <b-col lg="12">
            <label for="file">ChooseDoc</label>
            <input id="file" type="file" class="form-control">
          </b-col>
          <b-col lg="12" class="pt-2">
            <b-row>
                <b-col lg="6">
                    <b-button block size="sm" variant="primary" @click="createDoc()">Save</b-button>
                </b-col>
                <b-col lg="6">
                    <b-button block size="sm" variant="danger" @click="hideModal()">Cancel</b-button>
                </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-modal>
    </b-row> 
</template>

<script>
import axios from 'axios';
import {apiDomain,getHeader} from "@/config/config";

import vue from 'vue';
export default {
  
  name: 'DocList',
  data(){
    
    return {
      statuses:[
        {status:'PENDING'},
        {status:'DECLINED'},
        {status:'CONFIRMED'},
        {status:'INPROGRESS'},
      ],
      selectedUserId:0,
      fields: [
          {
            key: 'docId',
            label: 'docId',
          },
          {
            key: 'docName',
            label: 'DocumentName',
          },
          
          {
            key: 'createdDate',
            label: 'CreatedDate',
          },
          {
            key: 'actions',
            label: 'Actions',
          },
          
       
      ],
      isBusy:false,
      totalRows:0,
      currentPage: 1,
      perPage: 20,
      tableVariant:'light',
      filter:"",
      selectMode:'multi',
      selectedRows:[],

      
      docForm:{
        docId:0,
        docName:'',
        docPath:"",
      },
    }
    
  },
  methods:{
    hideModal(){
        this.$bvModal.hide("docModal");
    },
    clearForm(){
        this.docForm={
        docId:0,
        docName:'',
        docPath:"",
      };
    },
    showDocModal(){
        
        this.$bvModal.show("docModal");
    },
    createDoc(){
        axios.post(apiDomain+'/exchange/doc/create',this.docForm,{headers:getHeader()})
        .then(()=>{
            this.$bvModal.hide("docModal");
            this.sysChange();
        })
    },
   
    viewDoc(row){
      
      this.$bvModal.show("checkModal");
    },
    
    sysChange(){
      this.$refs.docTable.refresh();  
    },
    
    docProvider(ctx){
        //alert("yes");
        this.isBusy = false
        ctx.roleId=this.roleId;
        let promise = axios.post(apiDomain+'/exchange/doc/list',ctx,{headers:getHeader()});
        return promise.then((response) => {
          const result = response.data;
          this.isBusy = false
          this.totalRows=result.recordCount;
          //alert(JSON.stringify(result));
          return(result.items)
        }).catch(error => {
          this.isBusy = false
          return []
        })
    },
   
  }
  
}
</script>